<div class="container-fluid sidebar pb-2">
    <!--toggle-button-sidebar-->
    <div (click)="onToggleSidebar()" class="filter-backdrop">
        <div class="row box mb-0 pt-2 sticky-top position-relative-md bg-white">
            <div class="col-12 mt-2 mb-2">
                <button (click)="onToggleSidebar()"
                        class="button-borderless w-100 d-flex justify-content-between icon-height">
                    {{ 'search-filter.hide' | translate }}
                    <div class="d-inline-flex">
                        <ucs-icon [class]="'blue'" [shape]="'search'" [size]="24"></ucs-icon>
                        <ucs-icon [shape]="'double_angle_left'" [size]="16" class="me-1 blue"></ucs-icon>
                    </div>
                </button>
            </div>
        </div>
    </div>
    <ng-content/>
</div>
